import { StyleRulesCallback, Theme } from "@material-ui/core";
import { ICompanyAvatarProps } from "./CompanyAvatar";

export const styles: StyleRulesCallback<Theme, ICompanyAvatarProps> = ({
  palette,
}) => ({
  root: {
    backgroundColor: palette.common.white,
    border: `1px solid ${palette.gray.light}`,
  },
  fallback: {
    backgroundColor: palette.common.white,
  },
  sm: {
    width: "15px",
    height: "15px",
  },
  md: {
    width: "26px",
    height: "26px",
  },
  lg: {
    width: "30px",
    heigt: "30px",
  },
});
